import { Loading, useTrackPageChange } from "@ssf/components";
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";

import { routes } from "../lib/index.js";

const HomePage = lazy(() => import("../pages/HomePage.jsx"));

export const Router = () => {
  useTrackPageChange();

  return (
    <Routes>
      <Route
        path={routes.home}
        element={
          <Suspense fallback={<Loading />}>
            <HomePage />
          </Suspense>
        }
      />
      <Route
        path={routes.signedOut}
        element={
          <Suspense fallback={<Loading />}>
            <HomePage />
          </Suspense>
        }
      />
    </Routes>
  );
};
